import React from 'react'
import InfoPage from './InfoPage'
import meFull from "../../Assets/me2Full.png";

export default function Contact() {
    return (
        <>
            <InfoPage pic={meFull}>
                <h1>Contact</h1>
                <span />
                <p>At this time, I am working for Showplace Inc.</p>
                <p>If you would like to collaborate on anything, I would be happy to talk!</p>
                <br />
                <p>Jrwolf99@outlook.com</p>
                <p>(901)-220-0520</p>
                <a href='https://linkedin.com/in/jonathanrobertwolf' target="_blank" rel='noreferrer'> <p>Also, add me on linkedIn: here!</p></a>
            </InfoPage>
        </>
    )
}
